import { FormSectionHeader, Loader } from "@/components";
import useApprovalSettingsDtlCard from "./useApprovalSettingsDtlCard";
import { Card, CardContent } from "@/components/ui";
import { ReceiptText, Settings } from "lucide-react";

const ApprovalSettingsDtlCard = () => {
  const {
    roleApprovalSettingsCard,
    communityApprovalSettingsCard,
    isCommunityLimitLoading,
    communityDetail,
  } = useApprovalSettingsDtlCard();

  return isCommunityLimitLoading ? (
    <Loader />
  ) : (
    <Card className="shadow-none">
      <CardContent>
        <FormSectionHeader className="text-[18px] font-[500] flex flex-row items-center gap-2 text-primary">
          <Settings className="h-6 w-6 stroke-2" />
          APPROVAL SETTINGS
        </FormSectionHeader>
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-[20px]">
          <div className="bg-white rounded-lg">
            <FormSectionHeader>
              {communityDetail?.bomPosition?.positionName || ""} Approval Settings
            </FormSectionHeader>
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-[10px]">
              {roleApprovalSettingsCard?.map((data: any) => (
                <div className="text-[12px] flex flex-row items-center justify-between">
                  <div className="flex flex-row items-center gap-2">
                    <div className="h-6 w-6 flex items-center justify-center rounded-full bg-blue-100">
                      <ReceiptText className="h-3 w-3 stroke-primary" />
                    </div>
                    <label className="text-g-300">{data?.label}</label>
                  </div>
                  <div className="font-[600]">{data?.value}</div>
                </div>
              ))}
            </div>
          </div>
          <div className="bg-white rounded-lg lg:border-l lg:pl-5">
            <FormSectionHeader>Community Approvals</FormSectionHeader>
            <div className="grid grid-cols-1 gap-[10px]">
              {communityApprovalSettingsCard?.map((data: any) => (
                <div className="text-[12px] flex flex-row items-center justify-between">
                  <div className="flex flex-row items-center gap-2">
                    <div className="h-6 w-6 flex items-center justify-center rounded-full bg-blue-100">
                      <ReceiptText className="h-3 w-3 stroke-primary" />
                    </div>
                    <label className="text-g-300">{data?.label}</label>
                  </div>
                  <div className="font-[600]">{data?.value}</div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </CardContent>
    </Card>
  );
};

export default ApprovalSettingsDtlCard;
